import { BreadcrumbItem } from '../types'

export const buildBreadcrumbList = (pageUrl: string, items: BreadcrumbItem[]) => ({
  '@type': 'BreadcrumbList',
  '@id': `${pageUrl}#breadcrumb`,
  itemListElement: items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.name,
    item: item.item,
  })),
})
